import {
  FETCH_ALL_ORGANIZATION_MEMBERS,
  ADD_ORGANIZATION_MEMBER,
} from './../../mutation-types';

export default {
  [FETCH_ALL_ORGANIZATION_MEMBERS](state, organizationMembers) {
    state.all = organizationMembers;
  },
  [ADD_ORGANIZATION_MEMBER](state, organizationMember) {
    state.all.unshift(organizationMember);
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/organizationMember/mutations.js